<button [type]="btnType" [disabled]="disabled" class="sg-btn"
        [class.sg-btn--secondary]="btnStyle === 'secondary'"
        [class.sg-btn--tertiary]="btnStyle === 'tertiary'"
        [class.sg-btn--small]="btnSize === 'small'"
        [class.sg-btn--xsmall]="btnSize === 'xsmall'"
        [class.sg-btn--large]="btnSize === 'large'"
        [class.sg-btn--shadow]="btnShadow"
        [class.w-100]="fullWidth"
><mlp-ng-icon [name]="btnIcon" *ngIf="btnIcon" [class]="btnIconClass ? btnIconClass : ''"></mlp-ng-icon>{{ label }}<span *ngIf="labelSecondary" class="sg-btn--label">{{labelSecondary}}</span></button>
